import { createContainer } from "@roketus/web-toolkit";
import { Registry } from "../boundary/Registry";

export const container = createContainer<Registry>();

export const initContainer = container.initContainer;

export const getContainer = container.getContainer;
